/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EstimatedActivity,
  EstimatedActivity$inboundSchema,
  EstimatedActivity$Outbound,
  EstimatedActivity$outboundSchema,
} from "./estimatedactivity.js";

export type MoneyTransferPullFromCard = {
  estimatedActivity?: EstimatedActivity | undefined;
};

/** @internal */
export const MoneyTransferPullFromCard$inboundSchema: z.ZodType<
  MoneyTransferPullFromCard,
  z.ZodTypeDef,
  unknown
> = z.object({
  estimatedActivity: EstimatedActivity$inboundSchema.optional(),
});
/** @internal */
export type MoneyTransferPullFromCard$Outbound = {
  estimatedActivity?: EstimatedActivity$Outbound | undefined;
};

/** @internal */
export const MoneyTransferPullFromCard$outboundSchema: z.ZodType<
  MoneyTransferPullFromCard$Outbound,
  z.ZodTypeDef,
  MoneyTransferPullFromCard
> = z.object({
  estimatedActivity: EstimatedActivity$outboundSchema.optional(),
});

export function moneyTransferPullFromCardToJSON(
  moneyTransferPullFromCard: MoneyTransferPullFromCard,
): string {
  return JSON.stringify(
    MoneyTransferPullFromCard$outboundSchema.parse(moneyTransferPullFromCard),
  );
}
export function moneyTransferPullFromCardFromJSON(
  jsonString: string,
): SafeParseResult<MoneyTransferPullFromCard, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MoneyTransferPullFromCard$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MoneyTransferPullFromCard' from JSON`,
  );
}
